import { ChangePassword, GetMe, GetCompanyInformation, UpdateMe, setLanguage } from '@/api/account.js'
import { useToast } from 'vue-toastification'

const toast = useToast()

function getLocaleForLanguage (language) {
  if (typeof language !== 'string') {
    return 'sv'
  }

  if (language === 'Swedish' || language === 'Svenska') {
    return 'sv'
  } else if (language === 'English' || language.startsWith('Engelsk')) {
    return 'en'
  } else if (language === 'Norwegian' || language.startsWith('Norsk')) {
    return 'no'
  } else if (language === 'Danish' || language.startsWith('Dansk')) {
    return 'dk'
  }

  return 'sv'
}

const state = () => ({
  passwordType: 'password',
  eyeIcon: 'visibility_off',
  me: {},
  companyInformation: {},
  language: 'sv',
  contactInformationPromptVisible: false
})

// getters
const getters = {
  // External users (UK/GB02) can view and download but not create tasks, upload or send messages
  isReadOnly: (state) => state.me?.ReadOnly === true,
  hasAllCustomers: (state) => state.me?.AllCustomers === true,
  // Internal users (UK/GB02) can remove documents that were uploaded in the portal
  canDeleteDocuments: (state) => state.me?.CanDeleteDocuments === true
}

// Loads the logged in user once, for pages opened directly or after a reload
let meRequest = null

// actions
const actions = {
  async getMe ({ commit }) {
    const response = await GetMe()
    if (response && response.data && response.data.Customers && Array.isArray(response.data.Customers)) {
      response.data.Customers.sort((a, b) => a.Name.localeCompare(b.Name))
    }

    commit('setMe', response.data)
    commit('setLanguage', getLocaleForLanguage(response.data.Language))
    return response.data
  },
  async ensureMe ({ state, dispatch }) {
    if (state.me?.Email) {
      return state.me
    }
    if (!meRequest) {
      meRequest = dispatch('getMe').finally(() => {
        meRequest = null
      })
    }
    return meRequest
  },
  async updateMe ({ state, commit }, user) {
    const response = await UpdateMe(user)
    commit('setMe', {
      ...state.me,
      ...user
    })
    commit('setLanguage', getLocaleForLanguage(user.Language))
    return response
  },
  async getCompanyInformation ({ commit }) {
    try {
      const response = await GetCompanyInformation()
      if (response.status === 200) {
        // console.log(response)
        commit('setCompanyInformation', response.data)
      } else {
        // console.log(response)
      }
    } catch (e) {
      // console.log(e)
    }
  },

  toggleShowPassword ({ state, commit }) {
    if (state.passwordType === 'password') {
      commit('setPasswordType', 'text')
      commit('setEyeIcon', 'visibility')
    } else {
      commit('setPasswordType', 'password')
      commit('setEyeIcon', 'visibility_off')
    }
  },
  async handleChangePassword ({ commit }, parameters) {
    if (parameters.password.length < 8 || parameters.repeatPassword.length < 8) {
      toast.error('Password must exceed 7 characters!')
      return
    }
    if (parameters.password === parameters.repeatPassword) {
      const dict = {
        Email: localStorage.getItem('username'),
        NewPassword: parameters.password,
        Token: localStorage.getItem('token')
      }

      try {
        const passwordChangeRespone = await ChangePassword(dict)
        if (passwordChangeRespone.status === 200) {
          toast.success('Password changed!')
          commit('setEyeIcon', 'visibility_off')
        } else {
          toast.error(
            'Password change failed! \r\n\r\n' + passwordChangeRespone.status
          )
        }
      } catch (e) {
        toast.error(
          'Password change failed! \r\n\r\n' + e.message
        )
      }
    } else {
      toast.error('Passwords do not match!')
    }
  },
  async setLanguage ({ commit }, parameter) {
    if (!parameter) {
      return
    }
    const json = {
      Language: parameter
    }
    try {
      const result = await setLanguage(json)
      if (result.status === 200) {
        commit('setLanguage', parameter)
        // dispatch('getTaskById', state.currentTask.Id)
      } else {
        commit('setLanguage', 'sv')
      }
    } catch (e) {
      // console.log(e)
    }
  }
}

const mutations = {
  setPasswordType (state, value) {
    state.passwordType = value
  },
  setEyeIcon (state, value) {
    state.eyeIcon = value
  },
  setMe (state, data) {
    state.me = data
  },
  setCompanyInformation (state, data) {
    state.companyInformation = data
  },
  setLanguage (state, data) {
    state.language = data
  },
  showContactInformationPrompt (state) {
    state.contactInformationPromptVisible = true
  },
  hideContactInformationPrompt (state) {
    state.contactInformationPromptVisible = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
